// extracted by mini-css-extract-plugin
module.exports = {"content":"content-2_Iw9","header":"header-1S6yp"};